import React from 'react'

import { ROUTING_MEASURES } from 'cube/constants'
import { isNil } from 'ramda'

import { Link, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { useTrackDrillDownClickEvent } from 'components/conversation/hooks/useTrackDrilldownClickEvent'
import { ReportKPICard } from 'components/KPICard'
import useRoutingReportDrillDownQuery from 'components/routing/RoutingReportDrillDown/hooks/useRoutingReportDrillDownQuery.hook'
import { CONVO_DETAIL_REPORT_PATH } from 'layouts/ConversationsDetailReport/ConversationsDetailReport.constants'
import { TypeFormats } from 'utils/format'

import { DEAD_END_CHATS_RANGE_DESCRIPTION } from './DeadEndChats.constants'
import useDeadEndChats from './useDeadEndChats.hook'

export const DeadEndChats = () => {
  const {
    score,
    metric,
    isLoading,
    isError,
    hasNoData,
    totalRecords,
    totalRequests,
  } = useDeadEndChats()
  const { drillDownCubeQuery } = useRoutingReportDrillDownQuery(
    ROUTING_MEASURES.DEAD_END_COUNT
  )

  const { trackViewEvent } = useTrackDrillDownClickEvent(
    'RoutingDeadEndChatsKPICard'
  )

  const drillDownQueryString =
    CubeQueryStringAdapter.toQueryString(drillDownCubeQuery)

  return (
    <ReportKPICard
      isLoading={isLoading}
      isError={isError}
      hasNoData={hasNoData}
      title="Dead end chats"
      subtitle="How many chats result in no teammate response or fallback action?"
      score={score}
      metric={metric}
      metricRange={DEAD_END_CHATS_RANGE_DESCRIPTION}
      formatMetric={(deadEndChats: number) => TypeFormats.PERCENT(deadEndChats)}
    >
      {!isNil(totalRequests) && !isNil(totalRecords) && (
        <Text variant="metadata">
          {totalRecords.toLocaleString()} out of{' '}
          {totalRequests.toLocaleString()} routing requests
        </Text>
      )}
      {!!totalRecords && (
        <Link
          target="_blank"
          variant="inline"
          href={`${CONVO_DETAIL_REPORT_PATH}?${drillDownQueryString}`}
          onClick={() => trackViewEvent({ totalRecords: metric ?? 0 })}
        >
          View data
        </Link>
      )}
    </ReportKPICard>
  )
}
